import React from 'react'
import ViewActionsCell from '../cells/ViewActionsCell'
import ViewEnabledFlagCell from '../cells/ViewEnabledFlagCell'
import ViewTagsCell from '../cells/ViewTagsCell'

export const columnConfig = {
  columns: [
    {
      header: 'View ID',
      accessorKey: 'viewId',
      id: 'viewId',
      cell: ({ getValue }) => <span>{getValue()}</span>,
      enableSorting: true,
      size: 80
    },
    {
      header: 'Name',
      accessorKey: 'name',
      id: 'name',
      enableSorting: true,
      size: 350
    },
    {
      id: 'path',
      header: 'Path',
      accessorKey: 'path',
      enableSorting: true,
      size: 250
    },
    {
      id: 'tags',
      header: 'Tags',
      accessorKey: 'tags',
      cell: ({ getValue }) => <ViewTagsCell tags={getValue()} />,
      enableSorting: false,
      size: 140
    },
    {
      header: 'Version',
      accessorKey: 'version',
      id: 'version',
      enableSorting: true,
      size: 60
    },
    {
      id: 'liveView',
      header: 'Is Live',
      accessorKey: 'liveView',
      cell: ({ getValue }) => <ViewEnabledFlagCell enabled={!!getValue()} />,
      enableSorting: true,
      size: 80
    },
    {
      id: 'showInNavigation',
      header: 'Show in navigation',
      accessorKey: 'showInNavigation',
      cell: ({ getValue }) => <ViewEnabledFlagCell enabled={!!getValue()} />,
      enableSorting: true,
      size: 140
    },
    {
      id: 'actions',
      header: 'Actions',
      accessorFn: (row) => row,
      cell: ({ getValue }) => {
        const row = getValue()
        return <ViewActionsCell view={row} />
      },
      enableSorting: false,
      size: 320
    }
  ],
  defaultSort: [{ id: 'name', desc: false }]
}
